import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';
import api from '../api';

const LOGO_URL = "/assets/logo.png";

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', JSON.stringify(data));
      navigate('/admin/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e.msg || JSON.stringify(e)).join(' '));
      else setError('Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-darkBg flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-gray-500 text-sm hover:text-neonBlue transition-colors mb-8" data-testid="back-to-home-link">
          <ArrowLeft size={16} /> Back to Home
        </a>

        <div className="glass-card rounded-2xl p-8 sm:p-10">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="Logo" className="w-16 h-16 rounded-full mx-auto mb-4 ring-2 ring-neonBlue/30" />
            <h1 className="font-heading text-2xl font-bold text-white">Admin Panel</h1>
            <p className="text-gray-500 text-sm mt-1">Shunya Gatha Management</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label htmlFor="admin-email" className="block text-sm font-medium text-gray-400 mb-2">Email</label>
              <input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                placeholder="admin@shunyagatha.com"
                className="w-full px-4 py-3 bg-darkBg border border-white/10 rounded-xl text-white placeholder-gray-600 focus:border-neonBlue focus:ring-1 focus:ring-neonBlue/50 outline-none transition-all"
                required
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="block text-sm font-medium text-gray-400 mb-2">Password</label>
              <input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                placeholder="Enter password"
                className="w-full px-4 py-3 bg-darkBg border border-white/10 rounded-xl text-white placeholder-gray-600 focus:border-neonBlue focus:ring-1 focus:ring-neonBlue/50 outline-none transition-all"
                required
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="text-red-400 text-sm bg-red-500/10 px-4 py-3 rounded-xl border border-red-500/20">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-btn"
              className="w-full flex items-center justify-center gap-2 bg-neonBlue text-black font-bold py-3.5 rounded-full hover:bg-neonBlue/80 hover:shadow-[0_0_25px_rgba(0,240,255,0.4)] disabled:opacity-50 transition-all"
            >
              {loading ? (
                <span className="animate-spin w-5 h-5 border-2 border-black/30 border-t-black rounded-full" />
              ) : (
                <>
                  <Lock size={16} />
                  Login
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
